const { Core, Events } = Global;
const ENTER_KEY_IDENTIFIER = 'Enter';

customElements.define('clipboard-copy', class extends Core {
    propTypes = {
        'clipboard-text': String,
        'success-title': String,
        'success-msg': String,
        'as-fallback': Boolean
    }

    render() {
        if (this.prop('as-fallback') && ('share' in window.navigator)) return;

        this.$({
            click: this._setClipboard,
            keydown: this._handleEnterPress
        });
    }

    _setClipboard() {
        navigator.clipboard.writeText(this.prop('clipboard-text'));
        this.pub(Events.TOAST_NOTIFICATION, {  
            type: 'success',
            msg: this.prop('success-title') || '', 
            title: this.prop('success-msg') || ''
        })
    }

    _handleEnterPress(e) {
        if(e.key === ENTER_KEY_IDENTIFIER) {
            e.preventDefault();
            e.stopPropagation();
            this._setClipboard()
        }
    }
})